import React from 'react'

export const ProfilePage = () => {
  return (
    <div>TravelProfilePage</div>
  )
}
